import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonFi from "./site/content/fi/common";
import commonEn from "./site/content/en/common";

import {
  getLanguageFromPath,
} from "./site/config/routes";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Internationalization
  ============================================================

  URL on sivun kielen ensisijainen lähde.

  /
  /portfolio
  /kuvaukset
  = FI

  /en/
  /en/portfolio
  /en/sessions
  = EN

  Tämä ratkaisu on SEO:n kannalta paljon parempi kuin
  pelkästään localStorageen perustuva kielivalinta.
*/

function getInitialLanguage() {
  if (typeof window === "undefined") {
    return "fi";
  }

  return getLanguageFromPath(
    window.location.pathname
  );
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fi: {
        common: commonFi,
      },

      en: {
        common: commonEn,
      },
    },

    lng: getInitialLanguage(),
    fallbackLng: "fi",

    supportedLngs: [
      "fi",
      "en",
    ],

    defaultNS: "common",

    ns: [
      "common",
    ],

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
